import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import { useUIStore } from '@/core/stores/ui.store';
import { useActiveOrganization } from '@/features/organizations/public';
import type { SettingsSectionId } from '../types';
import { settingsNavGroups } from '../config/settingsNav.config';
import { ProjectSwitcher } from './sections/ProjectSwitcher';

export function SettingsNavPanel() {
  const { t } = useTranslation('settings');
  const activeSettingsSectionId = useUIStore((s) => s.activeSettingsSectionId);
  const setActiveSettingsSectionId = useUIStore((s) => s.setActiveSettingsSectionId);
  const { activeOrganization } = useActiveOrganization();
  const canManageOrg = activeOrganization?.role === 'owner' || activeOrganization?.role === 'admin';

  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      <div className="px-4 pt-5 pb-3 shrink-0">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
          {t('title')}
        </p>
      </div>

      <nav className="flex-1 overflow-y-auto px-3 pb-4 space-y-4">
        {settingsNavGroups.map((group) => (
          <div key={group.id}>
            {group.id === 'project' && (
              <div className="mb-3">
                <ProjectSwitcher />
              </div>
            )}

            <p className="px-2 mb-1 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              {t(group.labelKey)}
            </p>

            <ul className="space-y-0.5">
              {group.items
                .filter((item) => !item.adminOnly || canManageOrg)
                .map((item) => {
                  const isActive = activeSettingsSectionId === item.id;
                  return (
                    <li key={item.id}>
                      <button
                        type="button"
                        data-testid={`settings-nav-item-${item.id}`}
                        onClick={() => setActiveSettingsSectionId(item.id as SettingsSectionId)}
                        className={cn(
                          'w-full text-left px-3 py-2 rounded-lg text-sm transition-colors',
                          isActive
                            ? 'bg-primary/10 text-primary font-medium'
                            : 'text-muted-foreground hover:bg-muted hover:text-foreground',
                        )}
                      >
                        {t(item.labelKey)}
                      </button>
                    </li>
                  );
                })}
            </ul>
          </div>
        ))}
      </nav>
    </div>
  );
}
